import { type ZodType } from 'zod';
import {
  RequestSchema,
  type Request,
  type RequestRefusalReason,
  type TransitionKey,
} from '@magimp/shared';
import { request } from '../client.js';

// WHY (#585): every transition that carries data exposes a discriminated
//   body shape. The wire DTOs in `apps/backend/src/modules/requests/dto.ts`
//   are the source of truth — this mirror keeps the client one helper
//   per transition without forcing every caller to import a shared
//   union. `return` keeps the legacy `{ reason }` shape; `success`
//   posts `{ bidId }`; `refuse` posts `{ reason, comment? }`.
export type TransitionBody =
  | { reason?: string }
  | { bidId: string }
  | { reason: RequestRefusalReason; comment?: string };

export function transitionRequest(
  id: string,
  key: TransitionKey,
  body?: TransitionBody,
): Promise<Request> {
  const init: RequestInit = { method: 'POST' };
  if (body !== undefined) {
    init.body = JSON.stringify(body);
    init.headers = { 'content-type': 'application/json' };
  }
  return request<Request>(
    `/requests/${encodeURIComponent(id)}/transitions/${key}`,
    init,
    {},
    RequestSchema as unknown as ZodType<Request>,
  );
}
